import React from 'react';
import { useField } from 'formik';

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> {
  name: string;
  error?: boolean;
  helperText?: string;
  label?: string;
  id?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, helperText, label, id, name, ...props }, ref) => {
    const [field, meta] = useField(name);
    const inputId = id || `input-${Math.random().toString(36).substring(2, 11)}`;

    // Use Formik's error state if not manually provided
    const hasError = error || (meta.touched && meta.error);
    const errorMessage = helperText || (meta.touched && meta.error ? meta.error : '');

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            {label}
          </label>
        )}
        <input
          type={type}
          id={inputId}
          className={`w-full px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent placeholder-gray-400 focus:outline-none disabled:bg-gray-100 dark:disabled:bg-gray-700  disabled:cursor-not-allowed transition-colors ${hasError
            ? 'border-red-500 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500'
            : 'border-gray-300'
            } ${className || ''}`}
          ref={ref}
          {...field}
          {...props}
        />
        {errorMessage && (
          <p className={`mt-1 text-xs ${hasError ? 'text-red-600' : 'text-gray-500'}`}>
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
